import React from "react";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/data/site";

const CHAPTERS = [
  { n: "01", title: "Diagnose the Root Cause", text: "We don't patch symptoms. Moisture mapping and structural analysis pinpoint exactly where and why water enters — so the fix lasts.", img: IMG.team },
  { n: "02", title: "Engineer the Right System", text: "Every surface behaves differently. We select the precise waterproofing chemistry — PU, crystalline, APP or epoxy — matched to your structure.", img: IMG.waterMacro },
  { n: "03", title: "Apply With Precision", text: "Certified crews follow a strict, tested application process. Clean sites, measured layers, and flood testing before we call it done.", img: IMG.roof },
  { n: "04", title: "Guarantee the Result", text: "Up to 15 years of documented warranty, honoured with prompt service. Your peace of mind is engineered in.", img: IMG.villa },
];

export default function ManifestoChapters() {
  return (
    <section className="bg-white py-24 md:py-32" data-testid="manifesto">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="max-w-3xl mb-16">
            <span className="text-royal text-xs font-semibold tracking-[0.3em] uppercase">The JAL RAKSHAKK Method</span>
            <h2 className="font-display text-4xl md:text-6xl font-extrabold text-navy-deep mt-3 leading-[1.02]">
              A national-grade engineering process — <span className="text-gradient-blue">not a quick fix.</span>
            </h2>
          </div>
        </Reveal>

        <div className="space-y-px">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className={`grid md:grid-cols-12 gap-6 items-center py-10 border-t border-slate-200 group ${i % 2 ? "md:[direction:rtl]" : ""}`}>
                <div className="md:col-span-2 [direction:ltr]">
                  <span className="font-display text-6xl md:text-7xl font-extrabold text-slate-200 group-hover:text-royal/20 transition-colors">{c.n}</span>
                </div>
                <div className="md:col-span-5 [direction:ltr]">
                  <h3 className="font-display text-2xl md:text-3xl font-extrabold text-navy-deep">{c.title}</h3>
                  <p className="text-slate-600 mt-3 leading-relaxed">{c.text}</p>
                </div>
                <div className="md:col-span-5 [direction:ltr]">
                  <div className="overflow-hidden rounded-lg aspect-[16/10] border border-slate-200">
                    <img src={c.img} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
